import { render, staticRenderFns } from "./ProductFields.vue?vue&type=template&id=7e64d4f8&scoped=true&lang=pug&"
import script from "./ProductFields.vue?vue&type=script&lang=js&"
export * from "./ProductFields.vue?vue&type=script&lang=js&"
import style0 from "./ProductFields.vue?vue&type=style&index=0&id=7e64d4f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e64d4f8",
  null
  
)

export default component.exports